/* Grannyways Theme JS */

// Sticky header shadow on scroll
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 10);
  }, { passive: true });
})();

// Smooth cart count animation
document.addEventListener('DOMContentLoaded', () => {
  const cartLinks = document.querySelectorAll('.cart-link');
  cartLinks.forEach(link => {
    link.addEventListener('click', e => {
      link.style.transform = 'scale(0.96)';
      setTimeout(() => { link.style.transform = ''; }, 150);
    });
  });
});
